import { useDispatch, useSelector } from 'react-redux'
import { loadEnums } from 'enums/state/actions'
import { useQuery } from '@tanstack/react-query'
import { Time } from '@carsys/enums/time'
import { useIsAuthenticated } from 'hooks/use-is-authenticated'
import { IRootReducerState } from 'state/rootReducer'

const useGmsEnums = () => {
  const dispatch = useDispatch()
  const authenticated = useIsAuthenticated()
  const shopID = useSelector((state: IRootReducerState) => state.auth.currentShop)

  return useQuery(
    ['enums', 'gms'],
    async () => {
      const { Data } = await dispatch(loadEnums())
      return Data
    },
    {
      enabled: authenticated && !!shopID,
      cacheTime: Time.Hour * 24,
      staleTime: Time.Hour * 24,
      refetchOnWindowFocus: false
    }
  )
}

export default useGmsEnums
